import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, ReplaySubject, of, Subject } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { ActionCoCardModel, ActionCoDevisModel } from "../../../models";
import { CoreService, HttpService } from "../../../services";

@Injectable()
export class ActionCoService implements OnDestroy {

  constructor(
    protected http: HttpService,
    protected indParam: CoreService,    
  ) {
  }

  public Model: ActionCoCardModel = new ActionCoCardModel();

  private devisCreated: Subject<string> = new Subject();
  public DevisCreated$: Observable<string> = this.devisCreated.asObservable();
  public OnDevisCreated(idDevis: string) {
    this.devisCreated.next(idDevis);
    this.devisCreated.complete();
  }

  private devisSigned: Subject<boolean> = new Subject();
  public DevisSigned$: Observable<boolean> = this.devisSigned.asObservable();
  public OnDevisSigned(signed: boolean) {
    this.devisSigned.next(signed);
    this.devisCreated.complete();
  }

  private corpIsClient: Subject<boolean> = new Subject();
  public CorpIsClient$: Observable<boolean> = this.corpIsClient.asObservable();
  public OnCorpIsClient(isClient: boolean) {
    this.corpIsClient.next(isClient);
    this.corpIsClient.complete();
  }

  private documentDevis: Subject<boolean> = new Subject();
  public DocumentDevis$: Observable<boolean> = this.documentDevis.asObservable();
  public OnDocumentDevis() {
    this.documentDevis.next(true);
  }

  private actionCoCreated: Subject<string> = new Subject();
  public ActionCoCreated$: Observable<string>= this.actionCoCreated.asObservable();
  public OnActionCoCreated(idActionCo: string) {
    this.actionCoCreated.next(idActionCo);
    this.actionCoCreated.complete();
  }


  private missionAdd: Subject<boolean> = new Subject();
  public MissionAdd$ = this.missionAdd.asObservable();
  public OnMissionAdd() {
    this.missionAdd.next(true);
  }


  private contactAdd: Subject<boolean> = new Subject();
  public ContactAdd$ = this.contactAdd.asObservable();
  public OnContactAdd() {
    this.contactAdd.next(true);
  }


  private infoDevisModel: ActionCoDevisModel = new ActionCoDevisModel();
  public GetInfoDevis(model: ActionCoDevisModel): Observable<ActionCoDevisModel> {
    model.Mode = 'INITDEVIS';
    this.infoDevisModel = new ActionCoDevisModel();
    return this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, model).pipe(
      mergeMap((data: ActionCoDevisModel) => {
        this.infoDevisModel = data;
        return of(this.infoDevisModel);
      })
    )
  }

  public SetInfoDevis(model: ActionCoCardModel) {
    if (this.infoDevisModel) {
      if (this.infoDevisModel.Devis) {
        this.infoDevisModel.Devis.ReadOnly = model.Invoice.ReadOnly;
        this.infoDevisModel.Devis.DevisSigne = model.Invoice.DevisSigne;
        this.infoDevisModel.Devis.DateSignature = model.Invoice.DateSignature;
        this.infoDevisModel.Devis.DevisPerdu = model.Invoice.DevisPerdu;
        this.infoDevisModel.Devis.DatePerdu = model.Invoice.DatePerdu;
        this.OnDevisSigned(model.Invoice.DevisSigne);
      }
      if (this.infoDevisModel.PersonneMorale) {
        this.infoDevisModel.PersonneMorale.PersonneMorale = model.Customer.PersonneMorale;
        this.infoDevisModel.PersonneMorale.IsClient = model.Customer.IsClient;
      }
    }
  }



  ngOnDestroy(): void {
    this.contactAdd.unsubscribe();
    this.missionAdd.unsubscribe();
    this.documentDevis.unsubscribe();
  }
}
